const electric_estimated_reducer = (state =true, action) => {
	switch(action.type) {

		case 'SETELECTRIC_ESTIMATED':
			return action.payload;

		default:
			return state;

	}
}

export default electric_estimated_reducer;
